<template>
  <div>
    <div class="page_title">商品列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div style="border-bottom: 1px solid #e8e9f0">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo noneline"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1" class="title">出售中</el-menu-item>
          <el-menu-item index="3" class="title">未上架</el-menu-item>
          <el-menu-item index="4" class="title">回收站</el-menu-item>
        </el-menu>
      </div>
      <div class="container">
        <div class="searchbox">
          <el-form inline>
            <el-form-item label="商品名称">
              <el-input
                v-model="goods_name"
                placeholder="请输入"
                @change="search"
                style="width: 180px"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品编码">
              <el-input
                v-model="goods_code"
                placeholder="请输入"
                style="width: 180px"
                @change="search"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品分类">
              <el-cascader
                @change="search"
                v-model="category"
                :options="categoryList"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
                placeholder="选择后台分类"
                style="width: 180px"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="商户名称">
              <el-select
                v-model="shop_id"
                placeholder="请选择商户"
                clearable
                @change="search"
                style="width: 180px"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下架来源" @change="search" v-if="active == 3">
              <el-select
                v-model="off_source"
                placeholder="选择下架来源"
                style="width: 180px"
              >
                <el-option label="自主下架" value="1"> </el-option>
                <el-option label="未上架暂存仓库" value="5"> </el-option>
                <el-option label="自动下架" value="6"> </el-option>
              </el-select>
            </el-form-item>
            <el-button @click="reset">重置</el-button>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button
              type="primary"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2073') : false
              "
              @click="exportGoodsItemList"
              >导出商品</el-button
            >
          </el-form>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="sortChange"
          >
            <el-table-column label="排序" sortable="custom" prop="sort">
            </el-table-column>
            <el-table-column label="商品" width="300">
              <template slot-scope="scope">
                <div class="flex align-center">
                  <img
                    :src="scope.row.picture_str"
                    alt
                    style="width: auto; height: 76px; margin-right: 5px"
                  />
                  <p>{{ scope.row.goods_name }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              prop="create_time"
              sortable="custom"
            ></el-table-column>
            <el-table-column label="是否启用规格" prop="create_time">
              <template slot-scope="scope">
                <span v-show="scope.row.open_spec == 1">启用</span>
                <span v-show="scope.row.open_spec == 0">否</span>
              </template>
            </el-table-column>
            <el-table-column label="商品编码">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.goods_code" :key="index">
                  {{ item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="real_sales"
              label="实际销量"
              v-if="active == 1"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="stock"
              label="总库存"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              label="下架来源"
              v-if="active == 3 || active == 4"
              prop="off_shelf_reason"
            ></el-table-column>

            <el-table-column
              label="商户名称"
              prop="shop_name"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="toDetail(scope.row.goods_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('790')
                      : false
                  "
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageNumber"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="padding: 20px 0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      activeIndex: "1",
      active: 1,
      total: 0,
      page: 1,
      pageNumber: 10,
      tableData: [],
      goods_name: "",
      goods_code: "",
      off_source: "",
      shop_id: "",
      shopList: [],
      categoryList: [],
      category: [],
      order_sort: 0,
      multipleSelection: [],
      stockShow: false,
      rules: {
        stock: [
          {
            required: true,
            message: "请输入商品库存",
            trigger: "blur",
          },
        ],
      },
      info: {},
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getCategoryList();
    this.getShopList();
  },
  activated() {
    this.getList();
  },
  methods: {
    //获取分类列表
    getCategoryList() {
      this.axios
        .post("platform/ManageGoods/getGoodsCategoryList")
        .then((res) => {
          let list = res.data.list;
          let arr = [];
          list.forEach((ele) => {
            if (ele.child.length == 0) {
              arr.push({
                value: ele.category_id,
                label: ele.category_name,
              });
            } else {
              let childArr = [];
              ele.child.forEach((e) => {
                childArr.push({
                  value: e.category_id,
                  label: e.category_name,
                });
              });
              arr.push({
                value: ele.category_id,
                label: ele.category_name,
                children: childArr,
              });
            }
          });
          this.categoryList = arr;
        });
    },
    //获取商户列表
    getShopList() {
      this.axios
        .post("platform/shop/getShopListBase")
        .then((res) => {
          if (res.code == 0 && res.data && res.data.list) {
            this.shopList = res.data.list;
          }
        })
        .catch((err) => {
          console.error("获取商户列表失败", err);
        });
    },
    //获取列表
    getList() {
      this.tableData = [];
      let data = {
        page: this.page,
        pageNumber: this.pageNumber,
        goods_name: this.goods_name,
        off_source: this.off_source,
        type: this.active,
        goods_code: this.goods_code,
        order_sort: this.order_sort,
      };
      if (this.category[0]) {
        data.category_id_1 = this.category[0];
      }
      if (this.category[1]) {
        data.category_id_2 = this.category[1];
      }
      if (this.shop_id) {
        data.shop_id = this.shop_id;
      }
      this.axios.post("platform/shop/getGoodsList", data).then((res) => {
        this.total = res.data.total;
        let list = res.data.list;
        list.forEach((ele) => {
          ele.create_time = dayjs
            .unix(ele.create_time)
            .format("YYYY-MM-DD HH:mm");
        });
        this.tableData = list;
      });
    },
    handleSelect(key) {
      this.active = Number(key);
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    handleSizeChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.getList();
    },
    handleCurrentChange(size) {
      this.page = size;
      this.getList();
    },
    toAddGood() {
      this.$router.push("/goods/addGood");
    },
    reset() {
      this.goods_name = "";
      this.goods_code = "";
      this.category = [];
      this.shop_id = "";
      this.order_sort = 2;
      this.page = 1;
      this.pageNumber = 10;
      this.off_source = "";
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    },
    sortChange(e) {
      let prop = e.prop;
      let order = e.order;
      if (prop == "stock" && order == "descending") {
        this.order_sort = 2;
      } else if (prop == "stock" && order == "ascending") {
        this.order_sort = 1;
      } else if (prop == "create_time" && order == "descending") {
        this.order_sort = 4;
      } else if (prop == "create_time" && order == "ascending") {
        this.order_sort = 3;
      } else if (prop == "real_sales" && order == "descending") {
        this.order_sort = 8;
      } else if (prop == "real_sales" && order == "ascending") {
        this.order_sort = 7;
      } else if (prop == "stock" && order == "descending") {
        this.order_sort = 6;
      } else if (prop == "stock" && order == "ascending") {
        this.order_sort = 5;
      } else {
        this.order_sort = 0;
      }
      this.getList();
    },
    toDetail(goods_id) {
      this.$router.push({
        path: "goodsdetail",
        query: {
          goods_id,
        },
      });
    },
    // 构建导出参数（排除分页参数）
    buildExportParams() {
      let data = {
        goods_name: this.goods_name,
        off_source: this.off_source,
        type: this.active,
        goods_code: this.goods_code,
        order_sort: this.order_sort,
      };
      if (this.category[0]) {
        data.category_id_1 = this.category[0];
      }
      if (this.category[1]) {
        data.category_id_2 = this.category[1];
      }
      if (this.shop_id) {
        data.shop_id = this.shop_id;
      }
      return data;
    },
    // 导出商品
    exportGoodsItemList() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const params = this.buildExportParams();
      this.axios
        .post("platform/shop/exportGoodsItemList", params)
        .then((res) => {
          if (res.code == 0) {
            if (res.data && res.data.url) {
              const host = `${document.location.protocol}//${window.location.host}${res.data.url}`;
              window.open(host);
              this.$message.success("导出成功");
            } else {
              this.$message.error(res.message || "导出失败");
            }
          } else {
            this.$message.error(res.message || "导出失败");
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error("导出失败");
          loading.close();
        });
    },
  },
};
</script>

<style lang='scss' scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 205px);
  padding: 20px 20px 0;
}
.noneline {
  border: 0;
  padding: 0 20px;
}
.title {
  font-size: 16px;
  width: 90px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .item {
    margin-right: 20px;
    margin-bottom: 16px;
  }
}
</style>
